import { render } from "./ChurchUpdatesLayout.vue?vue&type=template&id=6f8f4247"
import script from "./ChurchUpdatesLayout.vue?vue&type=script&lang=js"
export * from "./ChurchUpdatesLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__